import { Rectangle2DCoordinates } from './geometry';

export const positionBasedKey = (
  position: Rectangle2DCoordinates,
  index: number
) => `${position[0]}-${position[1]}-${position[2]}-${position[3]}-${index}}`;
